<template>
  <div :key="component.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'component',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.componentId !== to.params.componentId) {
            if (await this.getComponentInfo(to.params.componentId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getComponentInfo: 'getComponentInfo',
        }),
    },
};
</script>
